export default function buildAdminUsersQuery(searchParams) {
  const params = new URLSearchParams(
    typeof searchParams === "string" ? searchParams : searchParams?.toString?.() || ""
  );
  const q = new URLSearchParams();

  const role = params.get("role");
  if (role && ["admin", "service_manager", "engineer", "all"].includes(role) && role !== "all") {
    q.set("role", role);
  }

  const status = params.get("status");
  if (status && ["active", "invited", "deactivated", "all"].includes(status) && status !== "all") {
    q.set("status", status);
  }

  return q.toString();
}
